import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SecurityService } from '../services/security.service';
import { LoggingService } from '../services/logging.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private loggingService: LoggingService,
    private securityService: SecurityService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  var logData = request != null ? JSON.parse(JSON.stringify(request)) : {};
    if (request.url.toLowerCase().includes('/account/authenticatesigninguser')) {
      if (logData.body["Password"] != undefined)
        logData.body["Password"] = "";
      if (logData.body["password"] != undefined)
        logData.body["password"] = "";
    }
    this.loggingService.Info(`Request=${JSON.stringify(logData)}`);
    // add authorization header with jwt token if available
    const currentUser = this.securityService.currentUserValue;
    // File upload to blob and cdn doesn't accept authorization header
    if (currentUser && !request.url.includes(environment.cdnEndPoint) && !request.url.includes('blob.core.windows.net') && !request.url.includes(environment.regDocService.url) && !request.url.includes(environment.masterLogEndPoint)) {
      const headers: any = {
        Authorization: `Bearer ${currentUser.Token}`,
        'accept': 'application/json'
      };
      // Don't set Content-Type for FormData (file uploads) — browser sets it with boundary
      if (!(request.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }
      request = request.clone({
        setHeaders: headers
      });
    }
    return next.handle(request);
  }
}
